import { Button, DatePicker, Form, Select, Space } from "antd";
import React, { useEffect, useState } from "react";

type companyRenewalProp = {
  onFormFinish: (company: ICompanyUserRenewal) => Promise<void>;
  onModalClose: () => void;
  isLoading: boolean;
  isSuccess: boolean;
};

const RenewCompanySubscriptions = ({
  onFormFinish,
  onModalClose,
  isLoading,
  isSuccess,
}: companyRenewalProp) => {
  const { RangePicker } = DatePicker;
  const [form] = Form.useForm();
  const [selectedSubPlan, setSelectedSubPlan] = useState<Number>();
  const [startDate, setStartDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();

  const handleSubChange = (value: any) => {
    setSelectedSubPlan(value);
  };

  const handleDateChange = (dates: any, dateString: [string, string]) => {
    setStartDate(dateString[0]);
    setEndDate(dateString[1]);
  };

  const onFinish = async (formValues: ICompanyUserRenewal) => {
    const values: ICompanyUserRenewal = formValues as ICompanyUserRenewal;
    values.validFrom = startDate as string;
    values.validTo = endDate as string;
    values.subTypeId = selectedSubPlan as number;
    await onFormFinish(values);
  };

  const handleClose = () => {
    form.resetFields();
    onModalClose();
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
    }
  }, [isSuccess]);

  return (
    <div>
      <Form name="renewSubscriptions" layout="vertical" onFinish={onFinish}>
        <div className="col-12">
          <Form.Item
            name={"subTypeId"}
            label="Select Subscription"
            rules={[
              { required: true, message: "Please select a subscription" },
            ]}
            className="mb-1"
          >
            <Select
              onChange={handleSubChange}
              placeholder="Subscription Plan"
              size="large"
              style={{ width: 485 }}
              options={[
                { value: 2, label: "Basic Plan" },
                { value: 8, label: "Family of Two" },
                { value: 3, label: "Family of Four" },
                { value: 4, label: "Family of Six" },
                { value: 5, label: "Premium" },
                { value: 9, label: "Family of Two Premium " },
                {
                  value: 6,
                  label: "Family of Four Premium",
                },
                {
                  value: 7,
                  label: "Family of Six Premium",
                },
              ]}
            />
          </Form.Item>
        </div>
        <div className="col-12">
          <Space
            direction="vertical"
            size={12}
            className="flex flex-row align-items-centers mt-2"
          >
            <Form.Item
              name={"dateRange"}
              label="Select Contract Period"
              rules={[
                { required: true, message: "Please select contract period" },
              ]}
              className="mb-1"
            >
              <RangePicker onChange={handleDateChange} />
            </Form.Item>
          </Space>
        </div>
        <Form.Item className="w-12 pt-2 mb-1">
          <div className="flex w-full gap-2 col-12 justify-content-end align-content-center">
            <Button
              onClick={handleClose}
              type="primary"
              ghost
              size="large"
              className="w-3"
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              className="w-3 bg-[#1757a2] shadow-none"
              loading={isLoading}
            >
              Save
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default RenewCompanySubscriptions;
